export default [
  {
    description:
      'check.periodic.irrigation.weather.demolished.excavated.roads.tracks',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'no.large.quantities.of.dust.are.generated',
  },
  {
    description: 'check.speed.limits.inside.worksite',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'signage.placed.respected',
  },
  {
    description: 'avoid.possible.earthworks.strong.very.strong.wind.conditions',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 0,
    acceptanceRejection: 'not.carried.out.conditions',
  },
  {
    description: 'check.wind.erosion.foreseen.aggregates.ballast.stockpiles',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'placement.tarpaulins.windbreak.barriers',
  },
  {
    description: 'check.vehicles.protective.measures.prevent.loss.dust',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection:
      '100.percent.availability.vehicles.traveling.outside.worksite',
  },
  {
    description:
      'check.asphalt.plants.filters.emission.controls.accredited.entities',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 3,
    acceptanceRejection:
      'check.asphalt.plants.filters.controls.carried.accredited.entities',
  },
  {
    description:
      'check.asphalt.plants.filters.emission.controls.carried.out.through.accredited.entities',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 3,
    acceptanceRejection: 'preventive.measures.place',
  },
  {
    description: 'check.established.schedules.execution.work.met',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 0,
    acceptanceRejection: 'schedule.compliance.default.hours',
  },
  {
    description:
      'check.pit.level.authorized.transporter.chemical.services.invoice',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 3,
    acceptanceRejection: 'emptying.authorized.transporter',
  },
  {
    description:
      'washing.concrete.tanks.channels.marking.signage.conditioning.washing.areas',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'washing.only.established.areas',
  },
  {
    description:
      'check.measures.prevent.washes.stockpiled.aggregates.rain.irrigation',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.protection.conditions',
  },
  {
    description:
      'check.measures.washes.stockpiled.rain.crushing.plants.washing',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection:
      'check.taken.washes.stockpiled.rain.crushing.plants.washing.irrigation',
  },
  {
    description: 'check.sufficient.sections.maintained.ensure.water.flow',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 0,
    acceptanceRejection: 'maintain.section.allows.drainage',
  },
  {
    description: 'check.material.stockpiles.not.made.flood.prone.areas',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 0,
    acceptanceRejection: 'no.stockpiles.made.flood.prone.areas',
  },
  {
    description: 'check.no.overexcavations.occur.during.earthworks.execution',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 0,
    acceptanceRejection: 'no.overexcavations.made',
  },
  {
    description: 'check.worksite.perimeter.marked.trees.ecological.protected',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.delimitation.protection',
  },
  {
    description: 'check.signage.necessary.worksite.access',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.signage',
  },
  {
    description: 'check.no.accesses.used.those.allowed',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 0,
    acceptanceRejection: 'no.more.accesses.used.allowed',
  },
  {
    description:
      'check.stockpiles.located.worksite.express.permit.place.alternative.areas',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 0,
    acceptanceRejection: 'stockpiles.inside.express.permit.place.outside',
  },
  {
    description:
      'conditioning.storage.toxic.wastes.least.one.fire.extinguisher',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection:
      'correct.storage.conditions.protection.prevent.accidental.spills',
  },
  {
    description:
      'correct.storage.conditions.protection.prevent.accidental.spills',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.conditions.each.area',
  },
  {
    description: 'check.conditioning.area.generator.set.installation',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'conditioned.areas',
  },
  {
    description:
      'check.precautions.protections.prevent.material.falls.sea.discharges',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.protection.conditions',
  },
  {
    description:
      'check.protections.prevent.water.turbidity.dredging.fill.works',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.protection.conditions',
  },
  {
    description:
      'check.works.not.carried.wave.heights.exceeding.one.meter.winds.exceeding',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 0,
    acceptanceRejection: 'correct.sea.conditions',
  },
  {
    description:
      'check.established.measures.leaks.product.during.transport.dredging',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.protection.conditions',
  },
  {
    description:
      'check.signaling.buoys.night.lighting.marine.worksite.occupation.area',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.signage',
  },
  {
    description:
      'check.upper.topsoil.works.recovered.restoration.processes.adequate.maintenance',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 0,
    acceptanceRejection: 'recovered.maintained.good.condition',
  },
  {
    description:
      'check.conditions.marking.strict.occupation.zone.auxiliary.access.roads',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: '',
    intensity: 0,
    acceptanceRejection: 'temporal.limitation.respected',
  },
  {
    description: 'register.water.consumption.during.execution.work',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 3,
    acceptanceRejection: 'maintained.reasonable.levels',
  },
  {
    description: 'register.fuel.consumption.during.execution.work',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 3,
    acceptanceRejection: 'maintained.reasonable.levels',
  },
  {
    description: 'register.electricity.consumption.during.execution.work',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 3,
    acceptanceRejection: 'maintained.reasonable.levels',
  },
  {
    description: 'check.signage.adaptation.waste.stockpile.areas',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.signage.adaptation',
  },
  {
    description:
      'check.waste.destination.invoices.contract.receiver.landfills.authorized',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'there.justifying.records',
  },
  {
    description:
      'check.segregation.wastes.non.hazardous.wastes.greater.extent.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'inert.wastes.not.mixed.with.other.types.wastes',
  },
  {
    description:
      'check.waste.destination.invoices.contract.landfills.authorized',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'there.justifying.records',
  },
  {
    description:
      'check.segregation.wastes.non.hazardous.greater.extent.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'inert.wastes.not.mixed.with.other.types.wastes.',
  },
  {
    description:
      'debris.check.waste.destination.invoices.contract.receiver.landfills.authorized',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'there.justifying.records',
  },
  {
    description:
      'debris.check.waste.destination.invoices.contract.receiver.landfills.authorized',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'inert.wastes.not.mixed.with.other.types.wastes.',
  },
  {
    description:
      'check.waste.destination.invoices.contract.receiver.landfills.authorized',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'there.justifying.records',
  },
  {
    description: 'vegetative.pruning.check.segregation.wastes.non.hazardous',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'inert.wastes.not.mixed.with.other.types.wastes.',
  },
  {
    description:
      'concrete.sleepers.check.waste.destination.notes.landfills.authorized',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'there.justifying.records',
  },
  {
    description: 'concrete.sleepers.check.segregation.wastes.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'inert.wastes.not.mixed.with.other.types.wastes.',
  },
  {
    description:
      'ballast.check.waste.destination.delivery.notes.contract.landfills.authorized',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'there.justifying.records',
  },
  {
    description:
      'ballast.check.segregation.wastes.non.hazardous.extent.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'inert.wastes.not.mixed.with.other.types.wastes.',
  },
  {
    description:
      'drilling.mud.check.waste.delivery.notes.contract.receiver.landfills.authorized',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'there.justifying.records',
  },
  {
    description:
      'drilling.mud.check.segregation.wastes.non.hazardous.hazardous',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'inert.wastes.not.mixed.with.other.types.wastes.',
  },
  {
    description:
      'non.hazardous.wastes.check.destination.delivery.notes.managers.authorized',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'there.justifying.records',
  },
  {
    description: 'non.hazardous.wastes.check.segregation.regarding.hazardous',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'do.not.mix.with.special.wastes',
  },
  {
    description: 'non.hazardous.wastes.check.should.tight.container.one',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'tight.container.available',
  },
  {
    description:
      'paper.cardboard.check.waste.destination.delivery.notes.managers.authorized',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'there.justifying.records',
  },
  {
    description: 'paper.cardboard.check.segregation.wastes.regarding.hazardous',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'do.not.mix.with.special.wastes',
  },
  {
    description: 'paper.cardboard.check.wastes.should.tight.container.one',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'tight.container.available',
  },
  {
    description:
      'plastics.check.waste.destination.delivery.notes.managers.authorized',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'there.justifying.records',
  },
  {
    description: 'plastics.check.segregation.wastes.regarding.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'do.not.mix.with.special.wastes',
  },
  {
    description: 'plastics.check.wastes.should.tight.container.one',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'tight.container.available',
  },
  {
    description: 'wood.check.waste.destination.records.available',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'tight.container.available',
  },
  {
    description: 'wood.check.segregation.wastes.regarding.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'do.not.mix.with.special.wastes',
  },
  {
    description: 'wood.check.wastes.should.tight.container.one',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'tight.container.available',
  },
  {
    description:
      'pallets.check.waste.destination.delivery.notes.managers.authorized',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'there.justifying.records',
  },
  {
    description: 'pallets.check.segregation.wastes.regarding.hazardous',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'do.not.mix.with.special.wastes',
  },
  {
    description: 'pallets.check.wastes.should.tight.container.one',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'tight.container.available',
  },
  {
    description:
      'wooden.sleepers.check.waste.destination.delivery.notes.managers.authorized',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'there.justifying.records',
  },
  {
    description:
      'wooden.sleepers.check.segregation..wastes.regarding.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'do.not.mix.with.special.wastes',
  },
  {
    description: 'wooden.sleepers.check..wastes.should.tight.container.one',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'tight.container.available',
  },
  {
    description:
      'iron.reinforcing.steel.check.waste.destination.delivery.notes.managers.authorized',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'there.justifying.records',
  },
  {
    description:
      'iron.reinforcing.steel.check.segregation.wastes.regarding.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'do.not.mix.with.special.wastes',
  },
  {
    description:
      'iron.reinforcing.steel.check.wastes.should.tight.container.one',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'tight.container.available',
  },
  {
    description:
      'tires.check.waste.destination.delivery.notes.managers.authorized',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'there.justifying.records',
  },
  {
    description: 'tires.check.segregation.wastes.regarding.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'do.not.mix.with.special.wastes',
  },
  {
    description: 'tires.check.wastes.should.tight.container.one',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'tight.container.available',
  },
  {
    description: 'hazardous.wastes.check.staging.area.conditioning',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'conditioned.areas',
  },
  {
    description: 'hazardous.wastes.check.segregation.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'segregated.wastes',
  },
  {
    description: 'hazardous.wastes.check.correct.identification.storage',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.adaptation.identification',
  },
  {
    description:
      'hazardous.wastes.check.subcontractors.remove.all.maintenance.wastes.site',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'no.containers.wastes.observed.work.area',
  },
  {
    description: 'aerosols.check.staging.area.conditioning.soil.etc',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'conditioned.areas',
  },
  {
    description: 'aerosols.check.segregation.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'segregated.wastes',
  },
  {
    description:
      'aerosols.check.correct.identification.storage.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.adaptation.identification',
  },
  {
    description:
      'aerosols.check.subcontractors.remove.all.maintenance.wastes.site',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'no.containers.wastes.observed.work.area',
  },
  {
    description: 'oils.containers.filters.check.staging.area.conditioning.etc',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'conditioned.areas',
  },
  {
    description: 'oils.containers.filters.check.segregation.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'segregated.wastes',
  },
  {
    description:
      'oils.containers.filters.check.correct.identification.storage.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.adaptation.identification',
  },
  {
    description:
      'oils.containers.filters.check.subcontractors.remove.all.maintenance.wastes.site',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'no.containers.wastes.observed.work.area',
  },
  {
    description: 'oils.ct.check.staging.area.conditioning.etc',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'conditioned.areas',
  },
  {
    description: 'oils.ct.check.segregation..wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'segregated.wastes',
  },
  {
    description:
      'oils.ct.check.correct.identification.storage.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.adaptation.identification',
  },
  {
    description:
      'oils.ct.check.subcontractors.remove.all.maintenance.wastes.site',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'no.containers.wastes.observed.work.area',
  },
  {
    description: 'asbestos.fibrocement.check.staging.area.conditioning.etc',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'conditioned.areas',
  },
  {
    description: 'asbestos.fibrocement.check.segregation.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'segregated.wastes',
  },
  {
    description:
      'asbestos.fibrocement.check.correct.identification.storage.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.adaptation.identification',
  },
  {
    description:
      'asbestos.fibrocement.check.subcontractors.remove.all.maintenance.wastes.site',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'no.containers.wastes.observed.work.area',
  },
  {
    description: 'machinery.batteries.check.staging.area.conditioning.etc',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'conditioned.areas',
  },
  {
    description: 'machinery.batteries.check.segregation.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'segregated.wastes',
  },
  {
    description:
      'machinery.batteries.check.correct.identification.storage.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.adaptation.identification',
  },
  {
    description:
      'machinery.batteries.check.subcontractors.remove.all.maintenance.wastes.site',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'no.containers.wastes.observed.work.area',
  },
  {
    description: 'batteries.check.staging.area.conditioning.etc',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'conditioned.areas',
  },
  {
    description: 'batteries.check.segregation.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'segregated.wastes',
  },
  {
    description:
      'batteries.check.correct.identification.storage.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.adaptation.identification',
  },
  {
    description:
      'batteries.check.subcontractors.remove.all.maintenance.wastes.site',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'no.containers.wastes.observed.work.area',
  },
  {
    description: 'paint.containers.check.staging.area.conditioning.etc',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'conditioned.areas',
  },
  {
    description: 'paint.containers.check.segregation.these.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'segregated.wastes',
  },
  {
    description:
      'paint.containers.check.correct.identification.storage.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.adaptation.identification',
  },
  {
    description:
      'paint.containers.check.subcontractors.remove.all.maintenance.wastes.site',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'no.containers.wastes.observed.work.area',
  },
  {
    description:
      'stripping.agent.containers.check.staging.area.conditioning.etc',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'conditioned.areas',
  },
  {
    description: 'stripping.agent.containers.check.segregation.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'segregated.wastes',
  },
  {
    description:
      'stripping.agent.containers.check.correct.identification.storage.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.adaptation.identification',
  },
  {
    description:
      'stripping.agent.containers.check.subcontractors.remove.maintenance.wastes.site',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'no.containers.wastes.observed.work.area',
  },
  {
    description: 'fuel.containers.check.staging.area.conditioning.etc',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'conditioned.areas',
  },
  {
    description: 'fuel.containers.check.segregation.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'segregated.wastes',
  },
  {
    description:
      'fuel.containers.check.correct.identification.storage.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.adaptation.identification',
  },
  {
    description:
      'fuel.containers.check.subcontractors.remove.all.maintenance.wastes.site',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'no.containers.wastes.observed.work.area',
  },
  {
    description: 'rags.gloves.check.staging.area.conditioning.etc',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'conditioned.areas',
  },
  {
    description: 'rags.gloves.check.segregation.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'segregated.wastes',
  },
  {
    description:
      'rags.gloves.check.correct.identification.storage.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.adaptation.identification',
  },
  {
    description:
      'rags.gloves.check.subcontractors.remove.all.maintenance.wastes.site',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'no.containers.wastes.observed.work.area',
  },
  {
    description: 'absorbents.check.staging.area.conditioning.etc',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'conditioned.areas',
  },
  {
    description: 'absorbents.check.segregation.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'segregated.wastes',
  },
  {
    description:
      'absorbents.check.correct.identification.storage.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.adaptation.identification',
  },
  {
    description:
      'absorbents.check.subcontractors.remove.all.maintenance.wastes.site',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'no.containers.wastes.observed.work.area',
  },
  {
    description: 'contaminated.soils.check.staging.area.conditioning.etc',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'conditioned.areas',
  },
  {
    description: 'contaminated.soils.check.segregation.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'segregated.wastes',
  },
  {
    description:
      'contaminated.soils.check.correct.identification.storage.hazardous.wastes',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.adaptation.identification',
  },
  {
    description:
      'contaminated.soils.check.subcontractors.remove.all.maintenance.wastes.site',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'correct.adaptation.identification',
  },
  {
    description: 'check.order.cleanliness.site',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'waste.removal.staging.area',
  },
  {
    description:
      'check.order.cleanliness.influence.area.work.cleaning.public.road',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'no.wastes.exist.work.area.construction.activity',
  },
  {
    description:
      'check.stockpiles.large.volumes.materials.not.made.sensitive.areas',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 1,
    acceptanceRejection: 'preliminary.study.before.starting.stockpiles',
  },
  {
    description:
      'check.during.earthworks.execution.archaeological.site.affected',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 0,
    acceptanceRejection: 'not.affected.case.any.issue.immediate.notification',
  },
  {
    description:
      'check.dredging.excavationno.archaeologically.found.presence.wreck',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 0,
    acceptanceRejection: 'not.affected.case.any.issue.immediate.notification',
  },
  {
    description:
      'check.access.roads.paths.maintained.permission.obtained.closure.diversion',
    responsible: 1,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 0,
    acceptanceRejection:
      'access.roads.paths.maintained.alternatively.permission.obtained',
  },
  {
    description: 'check.correct.signaling.work.zone.etc',
    responsible: 0,
    rule: 'environmental.technical.procedure',
    inspectionType: 'visual',
    intensity: 0,
    acceptanceRejection: 'correct.signaling.work.zone',
  },
];
